import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

function Games({ getID, getGameImg, getBackground, getGameID, getGameTitle }) {
	const [games, setGames] = useState([]);
	let reviews = [];
	const userLists = useRef([]);
	const userLogged = sessionStorage.getItem("logged");
	const userId = sessionStorage.getItem("userId");
	const addToListFormRef = useRef(null);
	const [showListsForm, setShowListsForm] = useState(false);
	let listsId = useRef([]);
	const gameid = useRef();
	const addToListBtnRef = useRef([]);
	const listGames = useRef([]);
	let lists = [];

	if (sessionStorage.getItem("reviews")) {
		reviews = JSON.parse(sessionStorage.getItem("reviews"));
	}

	if (sessionStorage.getItem("lists")) {
		lists = JSON.parse(sessionStorage.getItem("lists"));
		console.log(lists);
		userLists.current = lists.filter((list) => {
			return list.userId === userId;
		});
		console.log("user lists", userLists.current);
	}

	useEffect(() => {
		axios.get("api/gamesFunction").then((res) => {
			console.log(res.data);
			console.log(userId);
			console.log(userLists.current);
			console.log(listGames.current);
			setGames(res.data);
		});
	}, [userId]);

	function checkReview(gameID) {
		if (userLogged) {
			for (let review of reviews) {
				if (gameID === review.id) {
					return "/editreview";
				}
			}
			return "/createreview";
		} else {
			return "/games";
		}
	}

	function checkID(title) {
		console.log(title);
		getGameTitle(title);
		for (let review of reviews) {
			if (review.gameTitle === title) {
				getID(review.id);
				return;
			}
		}
		for (let game of games) {
			if (game.title === title) {
				getBackground(game.background);
				getGameID(game.id);
				getGameImg(game.img);
				return;
			}
		}
	}

	function checkIfLoggedIn() {
		if (!userLogged) {
			toast("Sign in to create a review", {
				style: { background: "#212529", color: "white", border: "1px solid gray" },
				duration: 2000,
			});
		}
	}

	function getGameId(gameId) {
		gameid.current = gameId;
		console.log("gameId", gameid.current);
		if (userLists.current.length) {
			setShowListsForm(!showListsForm);
		} else {
			toast("You don't have any lists created", {
				style: { background: "#212529", color: "white", border: "1px solid gray" },
				duration: 2000,
			});
		}
	}

	function addListId(listId) {
		if (listsId.current.includes(listId)) {
			listsId.current = listsId.current.filter((item) => {
				return item !== listId;
			});
		} else {
			listsId.current.push(listId);
		}
		console.log("lists id", listsId.current);
	}

	function addGameToList() {
		console.log(gameid.current);
		console.log(listsId);
		let game = games.find((game) => game.id === gameid.current);
		console.log(game);
		for (let id of listsId.current) {
			let alreadyInList = userLists.current.some((list) => {
				return list.id === id && list.games.find((item) => item.id === game.id);
			});

			console.log(alreadyInList);

			if (!alreadyInList) {
				console.log("add to database");
				for (let list of lists) {
					if (list.id === id) {
						list.games.push(game);
					}
				}
				sessionStorage.setItem("lists", JSON.stringify(lists));
				userLists.current = lists.filter((list) => {
					return list.userId === userId;
				});
				console.log(lists);
				console.log(userLists.current);
				toast.success("Added successfully", {
					style: {
						background: "#212529",
						color: "white",
						border: "1px solid gray",
					},
				});
			} else {
				console.log("already in list");
			}
		}
		listsId.current = [];
		setShowListsForm(false);
	}

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (showListsForm && !addToListFormRef.current.contains(e.target) && !addToListBtnRef.current.includes(e.target)) {
				console.log("useEffect ran");
				setShowListsForm(false);
			}
		};
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	});

	return (
		<div className="container mb-3">
			<div className="row text-center mt-2">
				<h1 className="text-white">Games</h1>
			</div>

			<div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 w-75 m-auto row-gap-1">
				{games.map((game, index) => {
					return (
						<div className="gamecol col rounded p-2 position-relative" key={game.id} onClick={checkIfLoggedIn}>
							<img
								className="myreview-game rounded w-100 "
								src={require(`../assets/images/${game.img}`)}
								alt={game.title}
								onClick={(e) => {
									checkID(e);
								}}
							/>
							<div className="hover-name text-center text-white fw-bold">{game.title}</div>

							{userLogged && (
								<div className="position-absolute bottom-0 start-50 translate-middle-x pb-3">
									<div
										className="add-to-list bg-dark rounded p-1 text-white mb-1 w-auto text-center"
										ref={(item) => addToListBtnRef.current.push(item)}
										onClick={() => getGameId(game.id)}>
										Add to list
									</div>
									<Link className="text-decoration-none" to={checkReview(game.id)}>
										<div
											className="add-to-list bg-dark rounded p-1 text-white w-auto text-center"
											onClick={() => {
												checkID(game.title);
											}}>
											Create/Edit Review
										</div>
									</Link>
								</div>
							)}
						</div>
					);
				})}
			</div>
			{showListsForm ? (
				<div
					className="listsForm row position-absolute bg-secondary top-50 start-50 translate-middle p-2 m-auto rounded"
					ref={addToListFormRef}>
					<div className="col-12 p-1">
						{userLists.current.map((list, i) => {
							return (
								<div className="list p-1 row justify-content-between w-100 m-auto" key={list.id}>
									<label className="text-white p-0 me-2 w-auto" htmlFor={"list" + i}>
										{list.title}
									</label>
									<input className="w-auto" type="checkbox" name={"list" + i} onClick={() => addListId(list.id)} />
								</div>
							);
						})}
						<div className="row justify-content-center w-100 m-auto">
							<button className="btn btn-primary mt-2 w-auto" onClick={addGameToList}>
								Add
							</button>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
}

export default Games;
